/**
 * DB 保存用: 郵便番号から数字以外を除去（ハイフン・空白など）
 */
export function normalizePostalCodeForStorage(value: string): string {
  if (value == null || typeof value !== 'string') return ''
  return value.replace(/\D/g, '')
}

/** 画面表示用: 7桁なら 123-4567 形式にする（それ以外は trim のみ） */
export function formatJapanesePostalCodeDisplay(value: string | null | undefined): string {
  const digits = normalizePostalCodeForStorage(String(value ?? ''))
  if (digits.length === 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`
  const t = String(value ?? '').trim()
  return t
}
